import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ClickAwayListener, Theme } from "@material-ui/core";
import { KSearchInput } from "@kyburz/kdesign-system";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "absolute",
    top: "2.813rem",
    left: 0,
    width: "100%",
    boxSizing: "border-box",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
  },
}));

const FilterField = ({
  column: { filterValue, setFilter },
  setActiveFilter,
}: any) => {
  const classes = useStyles();

  const close = () => setActiveFilter(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setFilter(e.target.value || undefined);

  const resetFilter = () => setFilter("");

  const handleClick = (e: any) => e.stopPropagation();

  return (
    <ClickAwayListener onClickAway={close}>
      <div className={classes.root} onClick={handleClick}>
        <KSearchInput
          onEndIconClick={resetFilter}
          width="100%"
          size="small"
          value={filterValue || ""}
          onChange={handleChange}
          searchIcon={false}
          autoFocus
        />
      </div>
    </ClickAwayListener>
  );
};

export default FilterField;
